module.exports = __webpack_public_path__ + "static/apple-touch-icon-912507a885d39aedb40b21a523e4ea92.png";